import React, { useEffect } from "react";
import { Form, notification } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { RootState } from "../../../../store";
import { usePostPaymentCivilInsertMutation, usePostPaymentMutation, usePrePaymentCivilInsertMutation, useGetPaymentConfigMutation } from "../../../../state/globalApi"; //usePostInfintechPaymentMutation,
import { LookupRequest } from "../../../../models/lookup-request";
import { buildPaymentConfigRequest, civilPaymentRequest, session } from "../../../../state/connect-api";
import axios from "axios";
import getConfigs from "../../../../GetConfigs";
import { setActiveTransactionId, getActiveTransactionId, setActiveCaseNumber } from "../../../../state/globalStore";

interface StateType {
  state: {
    fromPage?: string;
  };
  key: string;
  pathname: string;
  search: string;
  hash: string;
}

const useCivilEFilePayment = () => {
  const { casePayment: paymentData, activeCaseNumber } = useSelector((state: RootState) => state.global);
  const [res, setRes] = useState<any>();
  const history = useNavigate();

  const configurations = getConfigs(["activePayProcessor", "authorizeSandbox"]);
  const [postPay, { data, isLoading: paymentTokenLoading }] = usePostPaymentMutation();
  const [token, setToken] = useState<string>();
  const [prePaymentInsert, { data: preInsertData, isLoading: preInsertLoading }] = usePrePaymentCivilInsertMutation();
  const [postPaymentInsert, { data: postInsertData, isLoading: postInsertLoading }] = usePostPaymentCivilInsertMutation();
  //const [postPaymentInfintech, { data: postInfintechData, isLoading: infintechLoading }] = usePostInfintechPaymentMutation();
  const dispatch = useDispatch();
  const [getConfig] = useGetPaymentConfigMutation();
  const [transactionId, setTransactionId] = useState<string>();
  const [amount, setAmount] = useState<number>();
  const [amountData, setAmountData] = useState<boolean>(true);
  const [paymentLoader, setPaymentLoader] = useState<boolean>(false);
  const authorizeSandbox = configurations.authorizeSandbox == "true";
  const { activeTransactionId } = useSelector((state: RootState) => state.global);

  useEffect(() => {
    if (transactionId && amount != null) {
      handleMakePayment(amount);
    }
  }, [transactionId, amount]);

  const handleContinue = async (amount: number, moneyInCode) => {
    setAmount(amount);
    setAmountData(!amountData);
  };

  const handleMakePayment = async (amountDue) => {
    if (!amountDue) {
      notification.success({ message: "Civil Case Submitted Successfully" });
      const route = "/home";
      history(route);
      return;
    }
    if (transactionId == undefined) {
      if (dispatch(getActiveTransactionId()) == null) {
        return;
      } else {
        setTransactionId(activeTransactionId);
      }
    }
    setPaymentLoader(true);
    switch (configurations.activePayProcessor) {
      case "bridge":
        return bridgePayment(amountDue);
      //case "infintech":
      //  return infintechPayment(amountDue);
      case "paypal":
        return payPalPayment(amountDue);
      case "authorize":
        return authorizePayment(amountDue);
      default:
        console.log("payment not configured");
    }
  };
  const bridgePayment = async (amountDue) => {
    const bridgeConfigRequestItems = buildPaymentConfigRequest("bridge");
    const configRequest = await getConfig(bridgeConfigRequestItems).unwrap();
    const configValues = configRequest.Data;
    const configObject = configValues.reduce((acc, item) => {
      return {
        ...acc,
        [item.ConfigName]: item.ConfigValue
      };
    }, {});

    const form = document.createElement("form");
    form.method = "POST";
    form.action = configObject.payProcessorPayUrl;
    form.target = "_blank";
    const values = {
      PayerID: activeCaseNumber,
      AmountOwed: amountDue,
      ClientID: configObject.ClientID,
      TransactionReference: transactionId,
      SessionID: session,
      payPostBack: configObject.payPostBack,
      payProcessorAcctID: configObject.payProcessorAcctID,
      payProcessorKey: configObject.payProcessorKey
    };
    Object.keys(values).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = values[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    setPaymentLoader(false);
    notification.success({ message: "Civil Case Submitted Successfully" });
    const route = "/home";
    history(route);
  };
  //const infintechPayment = async (amountDue) => {
  //  const infintechOrderId = `${activeCaseNumber}-${transactionId}-${session}`;
  //  const JsonBody = {
  //    clientId: "", //infintechConfig.payProcessorClientID,
  //    orderId: infintechOrderId,
  //    preSharedKey: "", //infintechConfig.payProcessorPreSharedKey,
  //    redirectUrl: "", //"http://web1.civicacmi.com/Court/Default.aspx",
  //    principalAmount: amountDue,
  //    postUrl: "", //infintechConfig.postUrl,
  //    cancelUrl: "", //infintechConfig.cancelUrl,
  //    emailReceipt: "", //infintechConfig.emailReceipt,
  //    emailForm: "", //infintechConfig.emailForm,
  //    stationId: "", //`${infintechConfig.appid}-${infintechConfig.client_id}`,
  //    clerkId: null,
  //    cancelTimeout: "99999",
  //    items: [
  //      {
  //        itemId: "CT",
  //        name: `${activeCaseNumber} Court Payment`,
  //        quantity: "1",
  //        amount: amount
  //      }
  //    ]
  //  };

  //  const response = await postPaymentInfintech(JsonBody).unwrap();
  //  window.location.href = response.url;

  //  return response;
  //};

  const payPalPayment = async (amountDue) => {
    const payPalConfigRequestItems = buildPaymentConfigRequest("payPal");
    const configRequest = await getConfig(payPalConfigRequestItems).unwrap();
    const configValues = configRequest.Data;
    const configObject = configValues.reduce((acc, item) => {
      return {
        ...acc,
        [item.ConfigName]: item.ConfigValue
      };
    }, {});
    const formValues = {
      LOGIN: configObject.payProcessorAcctID,
      PARTNER: configObject.partner,
      TYPE: configObject.type,
      AMOUNT: amountDue,
      user1: activeCaseNumber,
      user5: configObject.user5,
      user7: configObject.applicationId,
      user6: configObject.siteId,
      user8: transactionId,
      user9: session,
      user10: null
    };

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://pilot-payflowlink.paypal.com/";
    form.target = "_blank";
    Object.keys(formValues).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = formValues[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    setPaymentLoader(false);
  };
  const authorizePayment = async (amountDue) => {
    const body = {
      getHostedPaymentPageRequest: {
        merchantAuthentication: {
          name: "",
          transactionKey: ""
        },
        transactionRequest: {
          transactionType: "authCaptureTransaction",
          amount: `${amountDue}`,
          lineItems: {
            lineItem: {
              itemId: "1",
              name: "Court Payment",
              quantity: "1",
              unitPrice: `${amountDue}`
              //description: "Court Payment"
            }
          },
          customer: {
            id: activeCaseNumber
          },
          userFields: {
            userField: [
              {
                name: "App",
                value: "CT"
              },
              {
                name: "Case",
                value: `${activeCaseNumber}`
              },
              {
                name: "trans",
                value: `${transactionId}`
              }
            ]
          }
          //billTo: {
          //  firstName: "",
          //  lastName: "",
          //  company: "",
          //  address: "",
          //  city: "",
          //  state: "",
          //  zip: "",
          //  country: "US"
          //}
        },
        hostedPaymentSettings: {
          setting: [
            {
              settingName: "hostedPaymentReturnOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentButtonOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentStyleOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentPaymentOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentSecurityOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentShippingAddressOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentBillingAddressOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentCustomerOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentOrderOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentIFrameCommunicatorUrl",
              settingValue: ""
            }
          ]
        }
      }
    };
    const response = await postPay(body).unwrap();
    setPaymentLoader(false);
    setRes(response.token);
    return response;
  };

  const handlePrePayment = async (activeCase, amountDue, moneyInCode) => {
    setAmount(amountDue);
    dispatch(setActiveCaseNumber(activeCase));
    const lookupRequest: LookupRequest = civilPaymentRequest(activeCase, `${amountDue}`, moneyInCode);
    const prepaymentRequest = await prePaymentInsert(lookupRequest).unwrap();
    setTransactionId(preInsertData?.MAIN[0]?.PAY_TRANSID);
    setTransactionId(prepaymentRequest?.MAIN[0]?.PAY_TRANSID);
    dispatch(setActiveTransactionId(preInsertData?.MAIN[0]?.PAY_TRANSID));
    dispatch(setActiveTransactionId(prepaymentRequest?.MAIN[0]?.PAY_TRANSID));
    return transactionId;
  };

  const handlePostPayment = async (responseData) => {
    //const remoteAddress = await axios.get("https://geolocation-db.com/json/");
    //const lookupRequest: LookupRequest = civilPaymentRequest(transactionId, activeCaseNumber, responseData?.totalAmount, "", responseData?.dateTime, remoteAddress?.data.IPv4);
    //const postpay = await postPaymentInsert(lookupRequest).unwrap();
  };

  return {
    paymentData,
    handleMakePayment,
    token,
    paymentTokenLoading,
    res,
    authorizeSandbox,
    preInsertLoading,
    handleContinue,
    paymentLoader,
    handlePrePayment
  };
};

export default useCivilEFilePayment;
